import { render, staticRenderFns } from "./fish.vue?vue&type=template&id=781ff6d0&scoped=true&"
import script from "./fish.vue?vue&type=script&lang=js&"
export * from "./fish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ff6d0",
  null
  
)

export default component.exports